import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import '../../css/editor.css';
import ApiService from '../../../../services/api';
import Add from '../../../../media/add.png';
import Category from '../../../../media/category.png';
import Back from '../../../../media/back.png';


const CreateCategory = () => {
  const [name, setName] = useState('');
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);

 const validate = () => {
    const errs = {};
    if (!name.trim()) errs.name = ["Inserisci nome categoria" , true];
    return errs;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    try {
      setSaving(true);
      await ApiService.newCategory({ name });
      toast.success("Categoria creata con successo");
      setName('');
      setErrors({});
      
      navigate('/admin/categorie');
    } catch (err) {
      console.error(err);
      toast.error("Errore durante la creazione");
    }
    finally {
      setSaving(false);
    }
  };

  return (
    <form className="editor-form" onSubmit={handleSubmit}>
      <div>
      <h2><img src={Category} alt="crea categoria" className="section-image" /> Crea categoria</h2>
      <button
        className="tab-button"
        style={{marginTop:'20px'}}
        onClick={() => navigate(`/admin/categorie`)}
        type='button'
      >
        <img src={Back} alt="Modifica" className="button-image" style={{marginTop:'-2.5px', marginRight:'2.5px'}}/>
        Torna all'elenco delle categorie
      </button>
      <label>Nome categoria *</label>
      <input
        type="text"
        name="name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        className={`input ${errors.name ? "error" : ""}`}
        maxLength={250}
      />
      {errors.name && <span className='error'>{errors.name}</span>}
      </div>
      

      <button disabled={saving}  type='submit' style={{ marginTop: "50px" }}>
        <img src={Add} alt="Aggiungi" className="button-image2" />
         {saving ? 'Creazione in corso...' : 'Crea categoria'}
      </button>
    </form>
  );
};

export default CreateCategory;
